export default __webpack_public_path__ + "images/bgpk2.62bab13.jpg";